import React from 'react'
import { SvgIconProps } from './Home'

const TooltipIcon = ({ fill, width, height }: SvgIconProps) => (
  <svg
    width={width ?? '25'}
    height={height ?? '24'}
    fill="none"
    viewBox={`0 0 25 24`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5 3C7.52128 3 3.5 7.02128 3.5 12C3.5 16.9787 7.52128 21 12.5 21C17.4787 21 21.5 16.9787 21.5 12C21.5 7.02128 17.4787 3 12.5 3ZM19.3936 12C19.3936 15.734 16.3298 18.8936 12.5 18.8936C8.67021 18.8936 5.60638 15.8298 5.60638 12C5.60638 8.17021 8.67021 5.10638 12.5 5.10638C16.3298 5.10638 19.3936 8.26596 19.3936 12Z"
      fill={fill ?? '#1573FF'}
    />
    <path
      d="M12.6761 17.375C12.0266 17.375 11.5 16.8484 11.5 16.1989V12.0057C11.5 11.3561 12.0266 10.8295 12.6761 10.8295C13.3257 10.8295 13.8523 11.3561 13.8523 12.0057V16.1989C13.8523 16.8484 13.3257 17.375 12.6761 17.375ZM12.6761 10.1477C12.358 10.1477 12.0852 10.0426 11.858 9.83239C11.6307 9.62216 11.517 9.36932 11.517 9.07386C11.517 8.77841 11.6307 8.52557 11.858 8.31534C12.0852 8.10511 12.358 8 12.6761 8C12.9972 8 13.2699 8.10511 13.4943 8.31534C13.7216 8.52557 13.8352 8.77841 13.8352 9.07386C13.8352 9.36932 13.7216 9.62216 13.4943 9.83239C13.2699 10.0426 12.9972 10.1477 12.6761 10.1477Z"
      fill={fill ?? '#1573FF'}
    />
  </svg>
)

export default TooltipIcon
